export default __webpack_public_path__ + "static/media/firewall.f3c3d172.svg";